import { render, staticRenderFns } from "./ProductsImport.vue?vue&type=template&id=d3e8fb2c&scoped=true"
import script from "./ProductsImport.vue?vue&type=script&lang=js"
export * from "./ProductsImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3e8fb2c",
  null
  
)

export default component.exports